// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3NxfO","ltr":"styles_ltr__3jW-2","rtl":"styles_rtl__X1hbC","modalContainer":"styles_modalContainer__1b9DY","overlay":"styles_overlay__2OWYS"};